<template>
    <v-dialog
        v-model="display"
        persistent
        width="400">
        <v-card>
            <v-card-title>طباعة</v-card-title>
            <v-card-text v-if="jobcard">
                هل تريد طباعة أمر الصيانة؟
                <div id="printMe" style="display: none">
                    <div dir="rtl">
                        <h3 class="center">مصنع بيترا للمنتجات الأسمنتية وأعمال الخرسانة الجاهزة</h3>
                        <h4 v-if="jobcard.workshop" class="text-center">{{jobcard.workshop}}</h4>
                        <div class="box">
                                <div>
                                    <table class="table table-bordered table-sm">
                                        <tr>
                                            <th>رقم امر الصيانة</th>
                                            
                                            <td>{{jobcard.the_code}}</td>
                                        </tr>
                                        <tr>
                                            <th>رقم اللوحة</th>
                                            <td>{{jobcard.plate_number}}</td>
                                        </tr>
                                        <tr>
                                            <th>نوع الالية</th>
                                            <td>{{jobcard.truck_type}}</td>
                                        </tr>
                                        <tr>
                                            <th>اسم السائق</th>
                                            <td>{{jobcard.driver_name}}</td>
                                        </tr>
                                        <tr>
                                            <th>الحالة</th>
                                            <td>{{jobcard.state}}</td>
                                        </tr>
                                        <tr>
                                            <th>العداد</th>
                                            <td>{{jobcard.odometer}}</td>
                                        </tr>
                                    </table>
                                    
                                </div>
                            <div>
                                <table class="table table-bordered table-sm">
                                    <tbody>
                                        <tr>
                                            <th>تاريخ الدخول</th>
                                            <td>{{jobcard.date_enter}}</td>
                                        </tr>
                                        <tr>
                                            <th>زمن الدخول</th>
                                            <td>{{jobcard.time_enter}}</td>
                                        </tr>
                                        <tr>
                                            <th>تاريخ الخروج</th>
                                            <td>{{jobcard.leave_date}}</td>
                                        </tr>
                                        <tr>
                                            <th>زمن الخروج</th>
                                            <td>{{jobcard.leave_time}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div> <!-- Failures -->
                            <h4>البلاغات</h4>
                            <table class="table table-bordered table-sm">
                                <v-col cols="12" md="3">
                                    <thead>
                                        <tr>
                                            <th class="small-width">#</th>
                                            <th>وصف البلاغ</th>
                                        </tr>
                                    </thead>
                                </v-col >
                                <v-col cols="12" md="6">
                                    <tbody>
                                        <tr v-for="(failure, index) in jobcardFailures" :key="index">
                                            <td>{{index + 1}}</td>
                                            <td>{{failure.description}}</td>
                                        </tr>
                                    </tbody>
                                </v-col>
                            </table>
                        </div>
                        <div> <!-- Failures -->
                            <h4>الصيانة</h4>
                            <table class="table table-bordered table-sm">
                                <thead>
                                    <tr>
                                        <th class="small-width">#</th>
                                        <th>وصف الصيانة</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(maintenance, index) in jobcardMaintenances" :key="index">
                                        <td>{{index + 1}}</td>
                                        <td>{{maintenance.description}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <h4>الأسبيرات</h4>
                            <table class="table table-bordered table-sm">
                                <thead>
                                    <tr>
                                        <th class="small-width">#</th>
                                        <th>البيان</th>
                                        <th>الكمية</th>
                                        <th>السعر</th>
                                        <th>الإجمالي</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(spare, index) in jobcardSpares" :key="index">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ spare.item_info.name }}</td>
                                        <td>{{ spare.quantity }}</td>
                                        <td>{{ spare.price }}</td>
                                        <td>{{ spare.quantity * spare.price }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="margin_top">
                            <h4>الصيانة الخارجية</h4>
                            <table class="table tabled-bordered table-sm">
                                <thead>
                                    <tr>
                                        <th class="small-width">#</th>
                                        <th class="three-width">الورشة</th>
                                        <th>البيان</th>
                                        <th>الكمية</th>
                                        <th>السعر</th>
                                        <th>الاجمالي</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(external_maintenance, index) in jobcardExternalMaintenances" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ external_maintenance.external_workshop }}</td>
                                        <td>{{ external_maintenance.description }}</td>
                                        <td>{{ external_maintenance.quantity }}</td>
                                        <td>{{ external_maintenance.price }}</td>
                                        <td>{{ external_maintenance.quantity * external_maintenance.price }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <br>
                        <hr>
                        تمت الطباعة بوساطة
                        {{ loggedInUser.name }}
                        <br>
                        تمت الطباعة في
                        {{ printTimestamp }}
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn 
                    @click="print"
                    text>طباعة</v-btn>
                <v-btn
                    @click="close"
                    text>إغلاق</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
export default {
    name: "jobcardPrintDialog",
    props: {
        jobcard: Object,
        jobcardFailures: Array,
        jobcardMaintenances: Array,
        jobcardSpares: Array,
        jobcardExternalMaintenances: Array
    },
    data() {
        return {
            display: false
        }
    },
    computed: {
        ...mapState("authentication", ["loggedInUser"]),
        printTimestamp() {
            return new moment().format("YYYY-MM-DD HH:mm")
        }
    },
    methods: {
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        async print() {
            const prtHtml = document.getElementById('printMe').innerHTML;
            const WinPrint =  window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinPrint.document.write(`<!DOCTYPE html>
            <html>
            <head>
            <style >
                table {
                    table-layout: fixed;
                    width: 100%;
                    font-family: arial, sans-serif;
                    border-collapse: collapse;
                    width: 100%;
                }

                td, th {
                    border: 1px solid #dddddd;
                    text-align: start;
                    padding: 8px;
                }
                tr:nth-child(even) {
                background-color: #dddddd;
                }
                
                .box {
                    display: flex
                }
                .small-width {
                    width: 10%
                }
                .center {
                    text-align: center;
                }
                .three-width {
                    width: 30%
                }
            </style>
            </head>
            <body>
                ${prtHtml}
            </body>
            </html>`);
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
            WinPrint.close();
        }
    }
}
</script>
